var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSearch2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.028 10.029l3.765 3.766a.706.706 0 01-.998.998l-3.766-3.766a5.6 5.6 0 11.998-.998h0zm-4.428.77a4.2 4.2 0 100-8.399 4.2 4.2 0 000 8.4z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  })));
}

export default SvgIconSearch2;